<script setup>
import { useI18n } from 'vue-i18n';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  canEdit: { type: Boolean, default: false },
  canRevise: { type: Boolean, default: false },
  preview: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
});

const emit = defineEmits(['back', 'edit', 'save-and-exit']);
const { t } = useI18n();
</script>

<template>
  <LaisHeader
    :title="t('REAL_ESTATE_COMMISSION_INSTALLMENT.TITLE')"
    :subtitle="t('REAL_ESTATE_COMMISSION_INSTALLMENT.SUBTITLE')"
    :breadcrumb="[
      { label: t('REAL_ESTATE_COMMISSION_SUPPORT.TITLE') },
      { label: t('REAL_ESTATE_COMMISSION_INSTALLMENT.TITLE') },
    ]"
    show-back
    :back-label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.BACK')"
    @back="emit('back')"
  >
    <template #actions>
      <LaisPrimaryButton
        v-if="preview && (canEdit || canRevise)"
        variant="ghost"
        icon="i-lucide-pencil"
        @click="emit('edit')"
      >
        {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.EDIT') }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        v-if="!preview && canEdit"
        variant="ghost"
        icon="i-lucide-log-out"
        :is-loading="saving"
        @click="emit('save-and-exit')"
      >
        {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.SAVE_AND_EXIT') }}
      </LaisPrimaryButton>
    </template>
  </LaisHeader>
</template>
